module.exports = __webpack_public_path__ + "static/media/onboardingTour.cd0ee0f4.png";